const handleApiError = async (response) => {
  if (!response.ok) {
    if (response.status === 401 || response.status === 403) {
      localStorage.removeItem('token');
      localStorage.removeItem('currentUser');
      window.location.reload();
      throw new Error('Oturum süresi doldu veya yetkiniz yok.');
    }
    const errorData = await response.json();
    throw new Error(errorData.message || 'Hata oluştu');
  }
};

export const fetchPeople = async (buildingId) => {
  if (!buildingId) {
    throw new Error('Bina ID zorunludur.');
  }
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/people?buildingId=${buildingId}`, {
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
  });
  await handleApiError(response);
  return response.json();
};

export const addPerson = async (personData) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/people`, {
    method: 'POST',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(personData),
  });
  await handleApiError(response);
  return response.json();
};

export const updatePerson = async (personId, personData) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/people/${personId}`, {
    method: 'PUT',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
    body: JSON.stringify(personData),
  });
  await handleApiError(response);
  return response.json();
};

export const deletePerson = async (personId) => {
  const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/people/${personId}`, {
    method: 'DELETE',
    headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, 'Content-Type': 'application/json' },
  });
  await handleApiError(response);
};